import { configureStore } from '@reduxjs/toolkit';

import inactivityMiddleware from './middlewares/inactivityMiddleware';
import notificationsMiddleware from './middlewares/notificationsMiddleware';
import rootReducer from './reducers';
import { mainServerAssistApi } from './services/assist';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- an explicit type breaks configureStore's generic inference
const setupStore = (preloadedState?: any) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
      }).concat(
        // RTK Query middleware must come first, or it fails to register and useQuery throws
        mainServerAssistApi.middleware,
        inactivityMiddleware,
        notificationsMiddleware,
      ),
  });

export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
export type RootState = ReturnType<AppStore['getState']>;

export default setupStore;
